import React, {Component} from 'react';
import {Redirect} from 'react-router-dom'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-solid';
import {create} from '../api/Api';

class Contact extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isStatusSuccess: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = {
      first_name: this.refs.firstName.value,
      last_name: this.refs.lastName.value,
      mobile: this.refs.mobile.value,
      email: this.refs.email.value,
      message: this.refs.message.value
    }
    create(data).then(res => {
      console.log(res.status);
      if (res.status === 201) {
        this.setState({
          isStatusSuccess: true
        })
      }
    })
  }

  render() {
    const {isStatusSuccess} = this.state;
    const {from} = this.props.location.state || '/';

    if (isStatusSuccess) {
      return <Redirect to="/about"/>
    } else {
      return (
        <div>
          <h3 className="uk-text-uppercase uk-text-bold">Get in touch with Me</h3>
          <div className="uk-animation-slide-top-small">
            <div uk-grid="true" className="uk-grid-divider">
              <div className="uk-width-1-2@l uk-width-1-2@m uk-width-1-2@xl uk-width-1-1@s">
                <p className="uk-margin-remove-bottom"><FontAwesomeIcon icon="address-card"/> Address: Bentonville , Arkansas 72712</p>
                <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="at"/> Email: sajidmd.***@*****.com</p>
                <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="phone-square"/> Phone: (669) ***-****</p>
                <p className="uk-margin-remove-top"><FontAwesomeIcon icon="globe"/> Website: <a href="http://sajidmohammed.com/" className="uk-link-heading" target="_blank">Sajid Mohammed</a></p>
              </div>
              <div className="uk-width-1-2@l uk-width-1-2@m uk-width-1-2@xl uk-width-1-1@s">
                <form onSubmit={this.handleSubmit}>
                  <div uk-grid="true">
                    <div className="uk-width-1-2">
                      <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="form-stacked-text">First Name</label>
                        <div className="uk-form-controls">
                          <input className="uk-input" id="form-stacked-text" type="text" ref="firstName" placeholder="First Name" required="true"/>
                        </div>
                      </div>
                    </div>
                    <div className="uk-width-1-2">
                      <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="form-stacked-text">Last Name</label>
                        <div className="uk-form-controls">
                          <input className="uk-input" id="form-stacked-text" type="text" ref="lastName" placeholder="Last Name" required="true"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div uk-grid="true" className="uk-margin-small-top">
                    <div className="uk-width-1-2">
                      <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="form-stacked-text">Mobile</label>
                        <div className="uk-form-controls">
                          <input className="uk-input" id="form-stacked-text" type="phone" ref="mobile" placeholder="Mobile" required="true"/>
                        </div>
                      </div>
                    </div>
                    <div className="uk-width-1-2">
                      <div className="uk-margin">
                        <label className="uk-form-label" htmlFor="form-stacked-text">Email</label>
                        <div className="uk-form-controls">
                          <input className="uk-input" id="form-stacked-text" type="email" ref="email" placeholder="Email" required="true"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="uk-margin">
                    <textarea className="uk-textarea" rows="5" placeholder="Message" ref="message" required="true"></textarea>
                  </div>
                  <div className="uk-margin">
                    <button className="uk-button uk-button-default uk-button-primary" type="submit">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {isStatusSuccess && (
            <Redirect to={from || '/about'}/>
          )}
        </div>
      )
    }
  }
}

export default Contact;



// WEBPACK FOOTER //
// src/components/Contact.js